/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PayWithRecurrentRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PayWithRecurrentRequest(value) {
    if (!('PublicId' in value) || value['PublicId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithRecurrentRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PublicId': json['PublicId'],
    };
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestToJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithRecurrentRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithRecurrentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PublicId': value['PublicId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PayWithRecurrentRequest.js.map